import { Dialog } from 'primeng/dialog'

import { DeviceService } from '@ti/core/common/services'

export function patchDialogFocus() {
  /**
   * Patch the `Dialog::focus` method to focus the dialog itself instead of its first field on phones
   *
   * A focused field opens the on-screen keyboard, which can land while the dialog or sheet is still animating in
   * The container takes no keyboard, and screen readers still move into the dialog
   */
  const orig__Dialog_focus = Dialog.prototype.focus
  Dialog.prototype.focus = function (...args) {
    if (!this.injector.get(DeviceService).isMobile()) {
      orig__Dialog_focus.call(this, ...args)
      return
    }

    const container = this.container()
    if (!container) return

    if (!container.hasAttribute('tabindex')) container.setAttribute('tabindex', '-1')
    container.focus({ preventScroll: true })
  }
}
